import React from "react";
import { TagContainer, Icon, IconContainer } from "./Tags.styles";
import { TagProps } from "./Tags.types";
import {
  Body6RegularTypography,
  Caps2SemiboldTypography,
} from "../../primitives/Typography/typographyVariants";
import { colorPalette } from "../../theme/colors";
// import { Info } from "lucide-react";

export const Tags: React.FC<TagProps> = ({
  type,
  label,
  discount,
  min,
  max,
  onClick,
  backgroundColor,
  color,
  icon,
  iconColor,
  dataCy,
  className,
}) => {
  let content;

  switch (type) {
    case "non-partner":
      content = (
        <Body6RegularTypography>Non-partner brands</Body6RegularTypography>
      );
      break;
    case "brand":
      content = <Body6RegularTypography>{label}</Body6RegularTypography>;
      break;
    case "blacklisted":
      content = <Body6RegularTypography>Blacklisted</Body6RegularTypography>;
      break;
    case "upto":
      content = (
        <Body6RegularTypography>@ Upto {discount}%</Body6RegularTypography>
      );
      break;
    case "flat":
      content = <Body6RegularTypography>@ {discount}%</Body6RegularTypography>;
      break;
    case "range":
      content = (
        <>
          <Body6RegularTypography>
            @ {min}% - {max}%
          </Body6RegularTypography>
          <IconContainer>
            <Icon className="fa-solid fa-circle-info" />
          </IconContainer>
        </>
      );
      break;
    case "payout":
      content = (
        <>
          <IconContainer>
            <Icon
              className={icon || "fa-solid fa-circle-info"}
              iconColor={iconColor}
            />
          </IconContainer>
          <Body6RegularTypography
            color={color || colorPalette.popWhite[500]}
            data-cy={dataCy}
          >
            {label}
          </Body6RegularTypography>
        </>
      );
      break;
    case "category":
      content = (
        <Caps2SemiboldTypography fontFamily="Lexend">
          {label}
        </Caps2SemiboldTypography>
      );
      break;
    case "unselected":
      content = (
        <Body6RegularTypography color={color || colorPalette.popBlack[200]}>
          {label}
        </Body6RegularTypography>
      );
      break;
    case "round":
      content = (
        <Body6RegularTypography color={color || colorPalette.popWhite[500]}>
          {label}
        </Body6RegularTypography>
      );
      break;
    case "whitelist":
      content = (
        <>
          <IconContainer>
            <Icon
              className={icon || "fa-solid fa-circle-info"}
              iconColor={iconColor}
            />
          </IconContainer>
          <Body6RegularTypography color={color || colorPalette.popWhite[500]}>
            {label}
          </Body6RegularTypography>
        </>
      );
      break;
    case "track":
      content = (
        <>
          <IconContainer>
            <Icon
              className={icon || "fa-solid fa-circle-info"}
              iconColor={iconColor}
            />
          </IconContainer>
          <Body6RegularTypography color={color || colorPalette.popWhite[500]}>
            {label}
          </Body6RegularTypography>
        </>
      );
      break;
    default:
      content = label;
  }

  return (
    <TagContainer
      type={type}
      backgroundColor={backgroundColor}
      color={color}
      onClick={(event) => {
        event.stopPropagation();
        if (onClick) onClick(event);
      }}
      className={className}
      data-cy={dataCy}
    >
      {content}
    </TagContainer>
  );
};

export default Tags;
